const mapSVG = require('../includes/map-svg');
const activity = () => {
    if ($("#activity").length) {
        $('.list-article').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: $('#prev-article'),
            nextArrow: $('#next-article'),
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        //xử lý map
        const map = mapSVG({
            element: $(".map"),
            onClickFunction: (map, id, name) => {
                onClickMap(map, id, name)
            }
        });
        map.restoreMapSize();
        if ($(".map").data("mode") == "view") {
            let data = map.getMapData();
            const firstId = Object.keys(data)[0];
            if (firstId) {
                $(".map").find(`#${firstId}`).click()
            }
        }

        if ($(".section1 .overview-menu").length) {
            let $parent = $(".overview-menu");
            let $icon = $parent.find(".overview-icon");
            let $list = $parent.find(".overview-list");
            $icon.on("click", function () {
                let isActive = $list.hasClass("active");
                $list.toggleClass("active");
                anime({
                targets: $list[0],
                height: isActive ? 79 : 640
                });
                $icon.css("transform", `rotate(${isActive ? '0deg' : '180deg'})`)
        
            })
        }

        if ($(".section5").length) {
            $('.section5 .project .project-title').click(function(){
                let listProject = $('.section5 .project .project-title');
                listProject.each(function(){
                    if($(this).hasClass('active')){
                        listProject.removeClass('active');
                    }
                })
                $(this).addClass('active');
            });
        }
    }
}
const onClickMap = (map, id, name) => {
    if ($(".map").data("mode") == "edit") {
        //example for edit in backend
        let data = map.getMapData(); //đây là data trước khi click. có dạng object: {id1: {color, icon}, id2: {color, icon}}
        const isSelected = data[id] ? true : false; //nếu id chưa có trong data cũ => thì là sự kiện select, còn không là sự kiện un-select
        if (!isSelected) {
            data[id] = {
                color: '#029B5C'
            }
        } else {
            delete data[id];
        }
        map.setMapData(data); //set data mới vào input hidden của map;
        map.restoreMapData() //restore để hiển thị lên map
    }
    else {
        //view mode
        const infos = JSON.parse($(".map input.data-on-click").val() || {})
        let info = infos.find(it => it.id === id);
        if (!info) return;
        $(".activity .info .title").html(name);
        $(".activity .info .content").html(info.content);
    }
}

module.exports = activity
